import React from "react";
import {Button, ButtonLink, ButtonRow, Card, OpenExternalLinkIcon} from "@myob/myob-widgets";
import "../../../common/Common.css"
import "../../../common/AccountPageStateStyle.css";
import * as PropTypes from "prop-types";
import helpUrls from "../../../HelpUrls";
import {redirectTo} from "../../../common/utils";

function OpenBankingFeedConfirmationView ({redirectUrl, summarySection, redirectToHelpPage, consumerId}) {
  const handleOnClick = () => {
    redirectTo(redirectUrl);
  }
  const isFromSolo = consumerId === "Solo";

  return (
    <div className='page-block animate'>
      <Card size={'xxl'}>
        {summarySection}
        {!redirectUrl && (
          <div style={{textAlign: 'center', marginTop: '20px'}}>
            <p>
              {isFromSolo? "Close this window.": "You can now close this window."}
            </p>
          </div>
        )}
      </Card>
        <ButtonRow className="animate"
                   primary={[
                     redirectUrl && (
                       <Button
                         className="finish-confirmation-for-open-banking"
                         style={{marginTop:'20px'}}
                         type="primary"
                         data-testid="done button"
                         tone="brand"
                         onClick={handleOnClick}>
                         Done
                       </Button>)
                   ]}
                   secondary={[
                     (!isFromSolo && helpUrls.GetHelpSettingUpBankUrl && <ButtonLink tone="info"
                                 icon={<OpenExternalLinkIcon/>}
                                 onClick={() => redirectToHelpPage("account_connected")}
                                 iconRight>Get help setting up a bank connection
                     </ButtonLink>)]}
        >
        </ButtonRow>

    </div>
  );
}

OpenBankingFeedConfirmationView.propTypes = {
  redirectUrl: PropTypes.string,
  summarySection: PropTypes.element,
  redirectToHelpPage: PropTypes.func,
  consumerId: PropTypes.string
};
export default OpenBankingFeedConfirmationView;
